import * as React from 'react';
import { Box, ParagraphText } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { richTextElementsCss } from '@web-config-app/core-react-ui';

export interface DefaultLocaleImagePreviewProps {
  defaultLocaleData?: string;
}

export const DefaultLocaleImagePreview: React.FC<
  DefaultLocaleImagePreviewProps
> = ({ defaultLocaleData }) => {
  const { formatMessage } = useIntl();

  if (defaultLocaleData) {
    return (
      <Box
        as="img"
        src={defaultLocaleData}
        alt=""
        css={{
          marginBlockStart: '$quarter',
          maxWidth: '100%',
          width: 'auto',
          height: 'auto',
          borderRadius: '$medium',
        }}
      />
    );
  }

  return (
    <ParagraphText
      css={{ marginBlockStart: '$quarter', ...richTextElementsCss }}
      emphasis="subtle"
    >
      {formatMessage({ id: 'EMPTY_DEFAULT_LOCALE_DATA' })}
    </ParagraphText>
  );
};
